import { render, staticRenderFns } from "./u-pagination-outlined-circle.vue?vue&type=template&id=53cb3c65&scoped=true"
import script from "./u-pagination-outlined-circle.vue?vue&type=script&lang=js"
export * from "./u-pagination-outlined-circle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cb3c65",
  null
  
)

export default component.exports